import Staff5 from "../assets/images/staff/staff1.jpg";

import Staff1 from "../assets/images/staff/staff2.jpg";
import Staff2 from "../assets/images/staff/staff3.jpg";
import Staff3 from "../assets/images/staff/staff5.jpg";
import Staff4 from "../assets/images/staff/staff4.jpg";
import Staff6 from "../assets/images/staff/staff6.jpg";
import Staff7 from "../assets/images/staff/staff7.jpg";
import Staff8 from "../assets/images/staff/staff8.jpg";
import Staff9 from "../assets/images/staff/staff9.jpg";
import Staff10 from "../assets/images/staff/staff10.jpg";
import Staff11 from "../assets/images/staff/staff11.jpg";
import Staff12 from "../assets/images/staff/staff12.jpg";
import Staff13 from "../assets/images/staff/staff13.jpg";
import Staff14 from "../assets/images/staff/staff14.jpg";
import Staff15 from "../assets/images/staff/staff15.jpg";
import Staff16 from "../assets/images/staff/staff16.jpg";
import Staff17 from "../assets/images/staff/staff17.jpg";
import Staff18 from "../assets/images/staff/staff18.jpg";

export const staffData = [
  {
    name: "Dr. Eleanor Hastings",
    portfolio: "Principal",
    qualification:
      "Ph.D. in Educational Leadership, M.Ed. in Curriculum Development",
    profile:
      "Dr. Hastings is a dynamic educational leader with over 15 years of experience fostering academic excellence and holistic student development. Her visionary leadership style emphasizes innovation, inclusivity, and student-centered learning environments. ",
    id: 1,

    photo: Staff1,
  },
  {
    name: "Mr. Chinedu Okafor",
    portfolio: "Vice Principal",
    qualification:
      "M.Ed. in Educational Administration, B.A. in English Literature",
    profile:
      "Mr. Okafor is a dedicated administrator known for his strategic thinking and commitment to student success. His approach blends academic rigor with effective leadership and community engagement.",

    photo: Staff2,
  },
  {
    name: "Mrs. Amelia Grant",
    portfolio: "Head of Science Department",
    qualification: " M.Sc. in Biological Sciences, B.Sc. in Biochemistry",
    profile:
      "Passionate about scientific discovery, Mrs. Grant inspires students to think critically and explore the wonders of the natural world through innovative experiments and inquiry-based learning",
    id: 3,

    photo: Staff5,
  },
  {
    name: "Mrs. Aisha Bello",
    portfolio: "Mathematics Coordinator",
    qualification:
      " M.Sc. in Applied Mathematics, B.Ed. in Secondary Education",
    profile:
      "Mrs. Bello has a knack for making complex mathematical concepts accessible and engaging. His teaching philosophy revolves around problem-solving and real-world applications of mathematics.",
    id: 4,

    photo: Staff3,
  },
  {
    name: "Mr. Ade Martinez",
    portfolio: "Head of Arts ",
    qualification: "M.A. in Fine Arts, B.A. in Art History",
    profile:
      "A creative force at Canterbury, Ms. Martinez nurtures artistic expression and cultural appreciation. Her classes blend traditional techniques with contemporary art forms, encouraging student creativity..",
    id: 5,

    photo: Staff12,
  },
  {
    name: "Mr. Adekunle Adebayo",
    portfolio: " Education Director",
    qualification: " B.Sc. in Sports Science, Certified Physical Trainer",
    profile:
      "Mr. Adebayo promotes physical fitness and healthy lifestyles through dynamic PE programs. His coaching fosters teamwork, discipline, and sportsmanship among students..",
    id: 6,

    photo: Staff7,
  },

  {
    name: "Mr. Emeka Nwosu",
    portfolio: " ICT Coordinator",
    qualification:
      " M.Sc. in Information Technology, B.Sc. in Computer Science",
    profile:
      "Mr. Nwosu integrates technology into the curriculum to enhance digital literacy. He encourages students to be innovators in the tech-driven world, focusing on coding, robotics, and cybersecurity.",
    id: 8,

    photo: Staff6,
  },

  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff4,
  },
  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff8,
  },
  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff9,
  },
  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff10,
  },
  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff11,
  },

  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff13,
  },
  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff14,
  },
  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff15,
  },
  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff16,
  },
  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff17,
  },
  {
    name: "Mr. Samuel Okoye",
    portfolio: "Social Studies Teacher",
    qualification: " M.A. in History, B.Ed. in Social Sciences",
    profile:
      "Mr. Okoye brings history to life with engaging storytelling and critical discussions. His classes encourage students to think deeply about historical events and their impact on the modern world. use a mixture of English and Nigerian names",
    id: 3,

    photo: Staff18,
  },
];
